import { apiFetch } from "./api";

export function createBoutique(data) {
  return apiFetch("/boutiques", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function getMyBoutiques() {
  return apiFetch("/boutiques/me");
}

export function updateBoutique(boutiqueId, data) {
  return apiFetch(`/boutiques/${boutiqueId}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}